import { GroupCallIcon } from "@/components/icons/GroupCallIcon";
import ReportIcon from "@/components/icons/ReportIcon";
import { Skeleton } from "@/components/ui/skeleton";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import React from "react";

interface AverageCallsPerAgentWidgetData {
  id: string;
  value: number;
  comparisonPercentage: number;
}

const AverageCallsPerAgentWidget: React.FC<{ data: AverageCallsPerAgentWidgetData; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <div className="text-[14px] font-[500] text-primary dark:text-white truncate">Average Calls Per Agent</div>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <GroupCallIcon className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The average number of calls were handled by an agent within a given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      {loading ? (
        <Skeleton className="h-16 w-full" />
      ) : (
        <>
          <div className="text-[24px] font-[700] text-primary dark:text-white my-3">
            {data.value ? Math.round(data.value) : "0"}
          </div>
          {/* <div className="text-[12px] font-[500]">
            {data.comparisonPercentage ? (
              <span
                className={
                  Number(data.comparisonPercentage.toFixed(2)) > 0
                    ? "text-green-600"
                    : Number(data.comparisonPercentage.toFixed(2)) < 0
                      ? "text-red-600"
                      : "text-primary dark:text-white"
                }
              >
                {data.comparisonPercentage > 0 ? "+" : ""}{data.comparisonPercentage.toFixed(2)}%
              </span>
            ) : (
              <span className="text-primary dark:text-white">0%</span>
            )}
            {" of total calls"}
          </div> */}
        </>
      )}
    </div>
  </div>
);

export default AverageCallsPerAgentWidget;
